import React, { useState } from "react";
import {
  Flex,
  HStack,
  Text,
  Box,
  VStack,
  IconButton,
  Image,
  Divider,
  Tooltip,
} from "@chakra-ui/react";
import { NavLink, useNavigate } from "react-router-dom";
import logoWithName from "../assets/waveflowmain/logo.png";
import logo from "../assets/waveflowmain/wavelogo.png";
import agentcreation from "../assets/waveflowmain/agentcreation.png";
import modal from "../assets/waveflowmain/modal.png";
import tools from "../assets/waveflowmain/Tools.png";
import workflow_admin from "../assets/waveflowmain/workflow_admin.png";
import blueReact from "../assets/sidenavbar/blueRectangle.png";
import purpleRect from "../assets/sidenavbar/purpleRectangle.png";
import orangRectangle from "../assets/sidenavbar/orangeRectangle.png";
import arrowDownBtn from "../assets/sidenavbar/arrowDownBtn.png";
import sidebarSlideIcon from "../assets/sidenavbar/sidebarSlideIcon.png";
import { ProfileCard } from "./ProfileCard";
import ThemeToggleTabs from "./DarkLightToggle";
import comingSoonOrange from "../assets/waveflowmain/comingSoonOrange.png";
import comingSoonBlue from "../assets/waveflowmain/comingSoonBlue.png";
import yellowColor from "../assets/waveflowmain/yellowColor.png";
import dataHubIcon from "../assets/waveflowmain/dataHub.png";
import yellowComingSoon from "../assets/waveflowmain/yellowComingSoon.png";

import comingSoonPurple from "../assets/waveflowmain/comingSoonPurple.png";
import {
  AgentInAction,
  HubOptionList,
  SidebarTop,
} from "./SidebarComponent/SidebarTop";
import CreditsInfo from "./UserCredit/UserCreditDetails";

const Sidebar = ({ children }) => {
  const [isOpen, setIsOpen] = useState(true);
  const [agentInAction, setagentInAction] = useState(true);
  const navigate = useNavigate();

  const handleClick = () => {
    setIsOpen(!isOpen);
  };

  const menuItem = [
    {
      path: "/Agent-Generation",
      name: "Agent Canvas",
      icon: agentcreation,
    },
    {
      path: "/models",
      name: "Model Hub",
      icon: modal,
    },

    {
      path: "/tools",
      name: "Tools",
      icon: tools,
    },
  ];

  const workflowLibraryObj = {
    path: "/workflow-admin",
    name: "Workflow Library",
    icon: workflow_admin,
  };

  const historyItem = [
    {
      // path: "/workflow-testing",
      path: "",
      name: "Agent Evaluation",
      icon: purpleRect,
      num: 16,
      img: comingSoonPurple,
    },
    {
      path: "",
      name: "Agent Leaderboard",
      icon: blueReact,
      num: 8,
      img: comingSoonBlue,
    },
    {
      path: "/Ai-Observability",
      name: "AI Observability",
      icon: orangRectangle,
      num: 4,
      img: comingSoonOrange,
    },
    {
      path: "",
      name: "Prompt Library",
      icon: purpleRect,
      num: 0,
      img: comingSoonPurple,
    },
    {
      path: "",
      name: "Documentation",
      icon: yellowColor,
      num: 16,
      img: yellowComingSoon,
    },
  ];

  const dataHub = [
    {
      name: "Data Hub",
      icon: dataHubIcon,
      path: "/data-hub",
      hubList: [
        {
          hubname: "File Hub",
          path: "#",
        },
      ],
    },
  ];

  const documentHub = {
    path: "/workflow-testing",
    name: "Documentation",
    icon: yellowColor,
    num: 16,
  };

  return (
    <>
      <Flex overflowX="hidden">
        <Box
          bg="rgba(20, 23, 24, 1)"
          color="white"
          position="fixed"
          height="100vh"
          transition="width 0.5s"
          width={isOpen ? "220px" : "50px"}
          display={"flex"}
          flexDirection={"column"}
          justifyContent="space-between"
          paddingX="1"
          overflow="hidden"
        >
          <Box flex="1">
            <HStack
              className="link"
              width="100%"
              p={2}
              _hover={{ bg: "gray.700", color: "white" }}
              transition="all 0.5s"
            >
              <Image
                onClick={handleClick}
                display={isOpen ? "none" : "block"}
                src={logo}
                w="80%"
                h="100%"
                objectFit="contain"
              />

              <VStack align="start" width="100%" mb={"15px"}>
                <HStack
                  style={{ width: "100%" }}
                  display="flex"
                  justifyContent="space-between"
                >
                  <Box
                    onClick={() => navigate("/Agent-Generation")}
                    w={"80%"}
                    display={isOpen ? "block" : "none"}
                  >
                    <Image w={"80%"} src={logoWithName} />
                  </Box>

                  <Box
                    display={isOpen ? "block" : "none"}
                    onClick={handleClick}
                  >
                    <Image src={sidebarSlideIcon} />
                  </Box>
                </HStack>
              </VStack>
            </HStack>
            <VStack align="start">
              {menuItem.map((item, index) => (
                <NavLink to={item.path} key={index} style={{ width: "100%" }}>
                  <SidebarTop item={item} isOpen={isOpen} />
                </NavLink>
              ))}
              {/* {dataHub &&
                dataHub?.map((ele, index) => (
                  <NavLink to={ele?.path} style={{ width: "100%" }}>
                    <HubOptionList ele={ele} index={index} isOpen={isOpen} />
                  </NavLink>
                ))} */}
              <NavLink to={workflowLibraryObj.path} style={{ width: "100%" }}>
                <SidebarTop item={workflowLibraryObj} isOpen={isOpen} />
              </NavLink>
            </VStack>
            <Divider borderColor="gray.700" />
            <VStack align="start" width="100%">
              <HStack
                style={{ width: "90%", margin: "auto" }}
                display="flex"
                justifyContent="space-between"
                // p={2}
              >
                <HStack
                  className="link"
                  width="80%"
                  boxSizing="border-box"
                  transition="all 0.5s"
                  onClick={() => setagentInAction(!agentInAction)}
                >
                  <Box as="span">
                    <Image src={arrowDownBtn} />
                  </Box>
                  <Text
                    color="rgba(108, 114, 117, 0.75)"
                    display={isOpen ? "block" : "none"}
                    fontSize="12px"
                  >
                    Agents in Action
                  </Text>
                </HStack>

                {/* <Box marginLeft="auto" p={1}>
                  <Image src={historyTimeIcon} />
                </Box> */}
              </HStack>
            </VStack>

            {agentInAction && (
              <Box>
                <VStack align="start">
                  {historyItem.map((item, index) => (
                    <AgentInAction item={item} index={index} isOpen={isOpen} />
                  ))}
                </VStack>
              </Box>
            )}
          </Box>
          <Box>
            <ProfileCard isOpen={isOpen} />
          </Box>
        </Box>
        <Box
          as="main"
          // width="100%"
          flex={1}
          marginLeft={isOpen ? "220px" : "50px"}
          transition="margin-left 0.5s"
          position="relative"
          h={"100vh"}
          borderRight="10px solid"
          borderTop="10px solid"
          borderBottom="10px solid"
          borderColor="rgba(20, 23, 24, 1)"
          boxSizing={"border-box"}
          bg={"rgba(20, 23, 24, 1)"}
          overflowX="hidden"
        >
          <Box
            borderRadius={"20px"}
            border={"1px solid red"}
            borderColor="rgba(20, 23, 24, 1)"
            h={"100%"}
            bg={"white"}
          >
            {children}
          </Box>
        </Box>
      </Flex>
    </>
  );
};

export default Sidebar;
